// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gt-line[data-v-1fd9b06e]{width:100%;height:1px;margin:10px 0}", ""]);
// Exports
module.exports = exports;
